/**
 * Location-only PGA section social wordmarks (SOCIAL PNGs from the shared Drive
 * logos folder). Prefer `PGASection_{LOCATION}_Social.png` — never `*_SECT_*`
 * lockups that read “Colorado Section” instead of “Colorado”.
 *
 * These are navy marks on a transparent canvas for light M360 chrome.
 * International (`290`) and National (`PGA`) are not in that folder.
 *
 * Source: https://drive.google.com/drive/folders/1EYvXiuJR4Izh_AfCELGjCEgzT7o5h7io
 */
import sectionSocialLogosManifest from "../../../../scripts/section-social-logos.manifest.json";

const pngBySlug = import.meta.glob<string>("./*.png", {
  eager: true,
  import: "default"
});

/** CCMS 3-digit section `legacyId` → kebab location slug (matches `{slug}.png`). */
export const SECTION_SOCIAL_LOGO_SLUG_BY_LEGACY_ID: Record<string, string> = Object.fromEntries(
  sectionSocialLogosManifest.files.map((file) => [file.legacyId, file.slug])
);

function srcForSlug(slug: string): string {
  const src = pngBySlug[`./${slug}.png`];
  if (!src) {
    throw new Error(`Missing section social logo PNG for slug "${slug}"`);
  }
  return src;
}

export const SECTION_SOCIAL_LOGO_BY_LEGACY_ID: Record<string, string> = Object.fromEntries(
  Object.entries(SECTION_SOCIAL_LOGO_SLUG_BY_LEGACY_ID).map(([legacyId, slug]) => [legacyId, srcForSlug(slug)])
);

export function getSectionSocialLogoSrc(legacyId: string | null | undefined): string | undefined {
  const id = legacyId?.trim();
  if (!id) return undefined;
  const key = /^\d+$/.test(id) ? id.padStart(3, "0") : id;
  return SECTION_SOCIAL_LOGO_BY_LEGACY_ID[key];
}
